import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Sidebar.css';
import { getStoredUser } from '../utils/authStorage';

const Sidebar = () => {
  const location = useLocation();
  const user = getStoredUser();
  const role = (user?.role || 'viewer').toLowerCase();
  const privilegedRoles = ['admin', 'manager', 'technician'];
  const hasFullAccess = privilegedRoles.includes(role);

  const isActive = (path) => location.pathname === path;

  return (
    <div className="sidebar">
      <h2>WebMonitor</h2>
      <ul>
        <li className={isActive('/dashboard') ? 'active' : ''}>
          <Link to="/dashboard">Dashboard</Link>
        </li>
        <li className={isActive('/my-websites') ? 'active' : ''}>
          <Link to="/my-websites">My Websites</Link>
        </li>
        {hasFullAccess && (
          <li className={isActive('/add-website') ? 'active' : ''}>
            <Link to="/add-website">Add Website</Link>
          </li>
        )}
        {hasFullAccess && (
          <li className={isActive('/backup') ? 'active' : ''}>
            <Link to="/backup">Backup</Link>
          </li>
        )}
        <li className={isActive('/reports') ? 'active' : ''}>
          <Link to="/reports">Reports</Link>
        </li>
        <li className={isActive('/monitoring') ? 'active' : ''}>
          <Link to="/monitoring">Site Overview</Link>
        </li>
        <li className={isActive('/security') ? 'active' : ''}>
          <Link to="/security">Security</Link>
        </li>
        <li className={isActive('/plugins') ? 'active' : ''}>
          <Link to="/plugins">Plugins</Link>
        </li>
        <li className={isActive('/activity-log') ? 'active' : ''}>
          <Link to="/activity-log">Activity Log</Link>
        </li>
        {hasFullAccess && (
          <li className={isActive('/users') ? 'active' : ''}>
            <Link to="/users">User Profile</Link>
          </li>
        )}
        {hasFullAccess && (
          <li className={isActive('/settings') ? 'active' : ''}>
            <Link to="/settings">Settings</Link>
          </li>
        )}
      </ul>
    </div>
  );
};

export default Sidebar;

